
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alu/multilevel",
      function () {
        return require("private-next-pages/alu/multilevel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alu/multilevel"])
      });
    }
  